import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";

const gaps = Object.fromEntries(
  Object.entries(theme.spacings).map(([key, value]) => [key, { gap: value }]),
);

export const revealStyle = recipe({
  variants: {
    renderAs: {
      flex: {
        display: "flex",
        flexDirection: "column",
      },
    },
    gap: {
      ...gaps,
    },
  },
});
